import React from "react";
import { imageUrlOthers } from "../../../../services/CommonUrl";
import pdfImg from "../../../../assets/images/pdf.png";
import DurationComponent from "../../../../components/departure-arrival-duration";
import { getIconForDaysType } from "../../../../components/icon-days-type";
import moment from "moment";
import { Link } from "react-router-dom";

const DayItem = ({ item, itemDeleteFnc, itemEditFnc, dateCheck }) => {
  const isPDF = (file) => typeof file === "string" && /\.pdf$/i.test(file);

  const outDate =
    item?.days_type == "Stays"
      ? item.checkOutDate
      : item?.days_type == "Tours"
        ? item.checkOutTime
        : item.to_date;

  return (
    item && (
      <div className="time-list-item">
        <div className="time-text">
          <span>
            {item?.tourStatus == "continue"
              ? "00:00"
              : item?.tourStatus == "end"
                ? moment(outDate).format("HH:mm")
                : item?.time}
          </span>
        </div>
        <div className="time-description">
          <div className="add-destination-item">
            <div className="a-d-left-bx">
              <div className="a-d-icon">
                {item?.icon?.length == 0 ? (
                  <img
                    src={getIconForDaysType(item?.days_type, item?.types[0])}
                    alt={item?.days_type || "Icon"}
                  />
                ) : (
                  <img
                    src={
                      isPDF(item?.icon[0])
                        ? pdfImg
                        : imageUrlOthers + item?.icon[0]
                    }
                    alt={item?.days_type || "Icon"}
                  />
                )}
              </div>
              <div className="a-d-item-info">
                <p className="mb-1">
                  <span className="a-d-type">
                    {item?.days_type === "Transports" ? item?.types[0] : item?.days_type}
                  </span>
                </p>
                <h5>{item?.name}</h5>
                <p>
                  <DurationComponent item={item} />
                </p>
                {item?.websiteLink && (
                  <a
                    href={item?.websiteLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-text"
                  >See Details</a>
                )}
              </div>
            </div>
            <div className="a-d-item-actions">
              <button
                type="button"
                onClick={() => itemEditFnc()}
                className="btn edit-icon"
                disabled={dateCheck}
              ></button>
              <button
                type="button"
                onClick={() => itemDeleteFnc()}
                className="btn delete-icon"
                disabled={dateCheck}
              ></button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default DayItem;
